import {
  SegmentedControl,
  type SegmentedOption,
} from "../segmented-control";

/** The three locked time-range presets (D-06). Mirrors the server rangeSchema. */
export type AnalyticsRange = "24h" | "7d" | "30d";

const RANGES: AnalyticsRange[] = ["24h", "7d", "30d"];

/** Caller-supplied (i18n-resolved) labels — the package stays free of react-i18next (D-20). */
export interface RangePresetLabels {
  /** Accessible name for the button group. */
  groupLabel: string;
  /** Per-range long accessible name + short visible chip text. */
  ranges: Record<AnalyticsRange, { label: string; short: string }>;
}

export interface RangePresetGroupProps {
  value: AnalyticsRange;
  onChange: (range: AnalyticsRange) => void;
  /** Disable interaction while a fetch is in flight. */
  disabled?: boolean;
  labels: RangePresetLabels;
}

/**
 * The 24h / 7d / 30d range presets (UI-SPEC Interaction). No date picker (D-06).
 * A thin adapter over the generic {@link SegmentedControl} (D5): it maps the three
 * locked ranges onto segments, keeping its exact public API (AnalyticsRange values,
 * label injection). The Atlas active segment is ink-filled by the shared control.
 */
export function RangePresetGroup({
  value,
  onChange,
  disabled = false,
  labels,
}: RangePresetGroupProps) {
  const options: SegmentedOption[] = RANGES.map((range) => ({
    id: range,
    label: labels.ranges[range].label,
    shortLabel: labels.ranges[range].short,
  }));

  return (
    <SegmentedControl
      options={options}
      value={value}
      onChange={(id) => onChange(id as AnalyticsRange)}
      groupLabel={labels.groupLabel}
      disabled={disabled}
    />
  );
}
